var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"yoprimary",staticStyle:{"background-color":"#00a650"},attrs:{"id":"token"}})}
var staticRenderFns = []

export { render, staticRenderFns }